import axios from "@main/axios";
import {isValidTel, isValidMail} from "@main/helpers/is-valid-field";
export default class FormBasic {
    formSection;
    documentHtmlLang = document.documentElement.getAttribute("lang");

    constructor(el) {
        this.el = el;
        this.url = this.el.dataset.url;
        this.requiredNodes = this.el.querySelectorAll("[required]");
        this.inputs = this.el.querySelectorAll("input");
        this.textarea = this.el.querySelectorAll("textarea");
        this.telField = this.el.querySelector(".js-tel-input");
        this.telFieldParent = this.telField?.parentElement;
        this.telErrorTextNode = this.telFieldParent?.querySelector(".error");
        this.mailField = this.el.querySelector(".js-mail-input");
        this.mailFieldParent = this.mailField?.parentElement;
        this.mailErrorTextNode = this.mailFieldParent?.querySelector(".error");
        this.nameField = this.el.querySelector(".js-name-input");
        this.submitBtn = this.el.querySelector(".js-form-submit-btn");
        this.recaptchaInput = this.el.querySelector(".js-recaptcha-response");
        this.documentEl = document.documentElement;
        this.yandex = window.config?.yandex.key;
        this.init();
    }

    init() {
        this.el.addEventListener("submit", e => {
            e.preventDefault();
            this.sendData();
        });


        if (this.el.closest("section[data-bound-form]")) {
            const sectionForm = this.el.closest("section[data-bound-form]");

            sectionForm.addEventListener("click", e => {
                if (e.target.classList.contains("js-form-submit-btn")) {
                    this.onClickBtnSubmit(e);
                }
            })
        } else {
            this.submitBtn.addEventListener("click", e => {
                this.onClickBtnSubmit(e);
            });
        }

        this.requiredNodes.forEach(node => {
            node.addEventListener("focus", () => {
                const parent = node.parentElement;
                parent.classList.remove("input-error");
            });
        });

        this.telField?.addEventListener("focus", () => {
            this.telFieldParent.classList.remove("input-error");
        });

        this.mailField?.addEventListener("focus", () => {
            this.mailFieldParent.classList.remove("input-error");
        });

        this.nameField.addEventListener("input", () => {
            this.preventEnteringNumbersInFieldName(this.nameField);
        });

        this.nameField.addEventListener("paste", () => {
            this.preventEnteringNumbersInFieldName(this.nameField);
        });
    }

    onClickBtnSubmit(e) {
        e.preventDefault();

        let isValid = true;
        let errorNodes = [];

        this.requiredNodes.forEach(node => {
            if (!node.value.trim().length) {
                errorNodes.push(node)
                const parent = errorNodes[0].parentElement;
                const errorText = parent.querySelector(".error");
                errorText.textContent = "Обязательное поле";
                parent.classList.add("input-error");
                isValid = false;
            }
        });

        if (
            this.telField &&
            !isValidTel(this.telField) &&
            this.telField.value.length !== 0
        ) {
            this.telFieldParent.classList.add("input-error");
            this.telErrorTextNode.textContent = "Номер телефона имеет неверный формат";
            isValid = false;
        }

        if (
            this.mailField &&
            this.mailField.value.length !== 0 &&
            !isValidMail(this.mailField)
        ) {
            this.mailFieldParent.classList.add("input-error");
            this.mailErrorTextNode.textContent = "Некорректный email";
            isValid = false;
        }

        if (isValid) {
            if (this.recaptchaInput && this.recaptchaInput && typeof grecaptcha !== "undefined" && window.config && window.config.recaptcha.public_key) {
                grecaptcha.ready(() => {
                    grecaptcha.execute(window.config.recaptcha.public_key, {action: "submit"}).then((token) => {
                        this.recaptchaInput.value = token;
                        this.sendData();
                    });
                });
            } else {
                this.sendData();
            }
            this.formSection = e.target.closest("section");
        }
    }

    showModal = (modalType, title, subtitle, link = undefined) => {
        const modal = document.querySelector(
            `.js-mch-modal[data-modal-name="${modalType}"]`
        );
        const titleNode = modal.querySelector(".js-modal-title");
        const subtitleNode = modal.querySelector(".js-modal-subtitle");
        const linkNode = modal.querySelector(".js-modal-link");
        const tryAgainBtn = modal.querySelector(".js-modal-try-again");

        if (titleNode && title) {
            titleNode.textContent = title;
        }

        if (subtitleNode && subtitle) {
            subtitleNode.textContent = subtitle;
        }

        if (linkNode && link) {
            linkNode.setAttribute("href", link);
        }

        if (tryAgainBtn) {
            tryAgainBtn.addEventListener("click", this.sendData);
        }

        modal.classList.add("shown");
        this.documentEl.classList.add("prevent-scroll");
        this.formSection?.scrollIntoView({block: "center", inline: "center"});
        this.submitBtn.removeAttribute("disabled");
    };

    /**
     * Если форма в модале, то после отправки данных, перед выводом
     * модала об успешной отправке, модал с формой закрываем.
     *
     * @param {Response} response Ответ, полученный при отправке данных формы.
     * @returns {void}
     */
    closeModalOnSendData(response) {
        const modals = document.querySelectorAll(".js-mch-modal");
        modals.forEach(modal => {
            if (modal?.classList.contains("shown")) {
                modal.classList.remove("shown");

                const title = response.data?.message
                    ? response.data.message
                    : "Все прошло отлично";

                this.showModal("success", title);
            }
        })
    }

    sendData = async () => {
        const data = new FormData(this.el);
        this.submitBtn.setAttribute("disabled", "disabled");

        try {
            const response = await axios({
                url: this.url,
                data,
                method: "POST"
            });

            if (response?.data?.success) {
                this.inputs.forEach(input => {
                    input.parentElement.classList.remove("filled");
                    input.value = "";
                });

                this.textarea.forEach(textarea => {
                    textarea.value = "";
                    textarea.parentElement.classList.remove("filled");
                });

                const title = response.data?.message
                    ? response.data.message
                    : "Все прошло отлично";
                this.showModal("success", title);
                this.closeModalOnSendData(response);
            }

            if (!response?.data?.success) {
                const title = response.data?.message
                    ? response.data.message
                    : "Что-то пошло не так";

                this.showModal("error", title);
            }
        } catch (error) {
            console.log(error);
            this.showModal("error");
        }
    };

    /**
     * Запрет ввода чисел в поле имени.
     *
     * @param {HTMLDivElement} field Контейнер поля вода.
     * @returns {void}
     */
    preventEnteringNumbersInFieldName(field) {
        if (field.classList.contains("js-name-input")) {
            field.value = field.value.replace(/[+$№^*)@:,.'`";_=<>%#~&!\\(?{}[\]/|\d]/g, "");
        }
    }
}

window.addEventListener("load", () => {
    document
        .querySelectorAll(".js-form-basic")
        .forEach(el => new FormBasic(el));
});
